import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (14.165 / 16);
  const localHeight = size * (13.565 / 16);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 14.165 13.565">
      <path
        d="M39.363,785.531a.959.959,0,0,0-.912.661l-1.235,3.781-3.978.006a.959.959,0,0,0-.563,1.735l3.214,2.343-1.223,3.785a.959.959,0,0,0,1.475,1.072l3.222-2.333,3.222,2.333a.959.959,0,0,0,1.475-1.072l-1.223-3.785,3.214-2.343a.959.959,0,0,0-.563-1.735l-3.978-.006-1.235-3.781a.959.959,0,0,0-.912-.661Z"
        transform="translate(-32.281 -785.531)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
